import { createFileRoute, redirect } from "@tanstack/react-router";

// Chapter Vials is now a real Shopify product page at /products/chapter-vials.
// This URL is preserved as a 301 redirect so existing links, social shares,
// and search results keep working.
export const Route = createFileRoute("/chapter-vials")({
  beforeLoad: () => {
    throw redirect({
      to: "/products/$slug",
      params: { slug: "chapter-vials" },
      statusCode: 301,
      replace: true,
    });
  },
});
